import Grid from "@mui/material/Grid";
import ValidatorSelectField from "../../FormFields/ValidatorSelectField";
import MenuItem from "@mui/material/MenuItem";
import EmailCheck from "../../EmailCheck/EmailCheck";
import ButtonLoading from "../../Button/ButtonLoading";
import ButtonTextTermsOfServicePrivacy from "../Common/ButtonTextTermsOfServicePrivacy/ButtonTextTermsOfServicePrivacy";
import React from "react";
import { useForm } from "../../../provider/Form/FormProvider";
import contractCheckinStyle from "./contractCheckinStyle";
import { emailDefault, requiredValidator } from "../../../services/validationRules";
import { translate } from "../../../services/translations/translations";

type SpecialEnergyContractCheckinFormProps = {
  emailErrorText: string;
  setEmailErrorText: (emailErrorText: string) => void;
  isLoading: boolean;
};

export default function SpecialEnergyContractCheckinForm({ emailErrorText, setEmailErrorText, isLoading }: SpecialEnergyContractCheckinFormProps) {
  const { handleSubmit, values } = useForm();
  return (
    <form onSubmit={handleSubmit}>
      <Grid
        container
        sx={{
          alignItems: "baseline",
          justifyContent: "center"
        }}>
        <Grid
          sx={contractCheckinStyle.gridSpaceMd}
          size={{
            xs: 12,
            md: 4
          }}>
          <ValidatorSelectField
            label={translate("providerContract.providerType.label", values)}
            name={`providerType`}
            validators={[requiredValidator("Bitte geben Sie die Art des Anbieters an.")]}
          >
            <MenuItem value={"electricity"}>{translate("providerContract.providerType.options.electricity.label", values)}</MenuItem>
            <MenuItem value={"gas"}>{translate("providerContract.providerType.options.gas.label", values)}</MenuItem>
          </ValidatorSelectField>
        </Grid>
        <Grid
          sx={contractCheckinStyle.gridSpaceMd}
          size={{
            xs: 12,
            md: 4
          }}>
          <ValidatorSelectField
            label={translate("providerContract.reasonForDispute.label", values)}
            name={`reasonForDispute`}
            validators={[requiredValidator("Bitte geben Sie das Problem mit dem Anbieter an.")]}
          >
            <MenuItem value={"priceIncrease"}>{translate("providerContract.reasonForDispute.options.priceIncrease.label", values)}</MenuItem>
            <MenuItem value={"serviceNotAsAgreed"}>{translate("providerContract.reasonForDispute.options.serviceNotAsAgreed.label", values)}</MenuItem>
            <MenuItem value={"cancellationByProvider"}>{translate("providerContract.reasonForDispute.options.cancellationByProvider.label", values)}</MenuItem>
            <MenuItem value={"cancellationRefused"}>{translate("providerContract.reasonForDispute.options.cancellationRefused.label", values)}</MenuItem>
            <MenuItem value={"invoiceIncorrect"}>{translate("providerContract.reasonForDispute.options.invoiceIncorrect.label", values)}</MenuItem>
            <MenuItem value={"other"}>{translate("providerContract.reasonForDispute.options.other.label", values)}</MenuItem>
          </ValidatorSelectField>
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 4
          }}>
          <EmailCheck
            name="email"
            label="Ihre E-Mail-Adresse"
            autoComplete="email"
            emailErrorText={emailErrorText}
            setEmailErrorText={setEmailErrorText}
            validators={[requiredValidator("Bitte geben Sie Ihre E-Mail-Adresse an"), emailDefault]}
          />
        </Grid>
        <Grid
          sx={[contractCheckinStyle.submit, contractCheckinStyle.gridTopSpaced]}
          size={{
            xs: 12,
            sm: 4
          }}>
          <ButtonLoading variant="contained" color="primary" sx={contractCheckinStyle.button} type="submit" fullWidth isLoading={isLoading}>
            Jetzt starten
          </ButtonLoading>
          <ButtonTextTermsOfServicePrivacy />
        </Grid>
      </Grid>
    </form>
  );
}
